"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var Balance_1 = require("./Balance");
var BonusPercent_1 = __importDefault(require("./BonusPercent"));
var Profile_1 = require("./Profile");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AuthMenu = function (_a) {
    var searchRightMobile = _a.searchRightMobile;
    var t = (0, next_intl_1.useTranslations)('translation');
    var globalConfig = (0, swr_hooks_1.useConfig)();
    var pathname = (0, navigation_1.usePathname)();
    var isBettingPage = /betting\/\w*/.test(pathname);
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var openUserBalance = (0, apps_shared_1.useOpenUserBalance)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var openSearch = (0, apps_shared_1.useOpenGameSearch)();
    var balance = (0, swr_hooks_1.useBalance)().data;
    var showBalance = (0, react_1.useMemo)(function () {
        var isGamePage = /game\/\w*/.test(pathname);
        return !isGamePage && !isBettingPage;
    }, [pathname, isBettingPage]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.headerProfileWrapper },
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && (react_1.default.createElement(react_1.default.Fragment, null,
            showBalance && react_1.default.createElement(Balance_1.Balance, null),
            react_1.default.createElement("div", { onClick: openDeposit, className: "".concat(styles_module_scss_1.default.buttonWrapper) },
                react_1.default.createElement(BonusPercent_1.default, null),
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "32px" }, t('deposit'))),
            react_1.default.createElement(Profile_1.Profile, null))),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) &&
            !globalConfig.authMenuButtonDeposit && (react_1.default.createElement(react_1.default.Fragment, null,
            !searchRightMobile && (react_1.default.createElement("div", { className: styles_module_scss_1.default.balanceWrapper },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.totalBalance, onClick: openUserBalance }, balance
                    ? "".concat((0, apps_shared_1.getCurrencySymbol)(balance === null || balance === void 0 ? void 0 : balance.currency)).concat((0, apps_shared_1.formatNumberShort)(Number(balance === null || balance === void 0 ? void 0 : balance.totalAmount)))
                    : ''),
                react_1.default.createElement(image_1.default, { onClick: openDeposit, src: "/img/icons/plusInCircle.svg", alt: "plus", width: "20", height: "20" }))),
            searchRightMobile && (react_1.default.createElement("button", { className: styles_module_scss_1.default.searchButton, onClick: openSearch })))),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) &&
            globalConfig.authMenuButtonDeposit &&
            (!isBettingPage ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.authMenuButtonDepositWrapper },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.authMenuButtonDepositAmount }, balance
                    ? "".concat((0, apps_shared_1.getCurrencySymbol)(balance === null || balance === void 0 ? void 0 : balance.currency)).concat((0, apps_shared_1.formatNumberShort)(Number(balance === null || balance === void 0 ? void 0 : balance.totalAmount)))
                    : ''),
                react_1.default.createElement("div", { onClick: openDeposit, className: styles_module_scss_1.default.authMenuButtonDepositButtonWrapper },
                    react_1.default.createElement(BonusPercent_1.default, null),
                    react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "32px" }, t('deposit'))))) : (react_1.default.createElement("div", { onClick: openDeposit, className: styles_module_scss_1.default.authMenuButtonDepositButtonWrapper },
                react_1.default.createElement(BonusPercent_1.default, null),
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "32px" }, t('deposit')))))));
};
exports.default = react_1.default.memo(AuthMenu);
